export const createQueryFilter = (value) => {
    return Object.entries(value)
        .filter(([key, value]) => value !== undefined)
        .map(([key, value]) => `${key}:${value}`)
        .join('|');
};
